export class Common {
    id: string;
    vesselId: string;
    language: CommonLanguageType;
    masterClockType: MasterClockType;
    UtcEnable: Status;
    japanCoastGuard: Status;
}

export type Status = 0 | 1;

export const commonLanguages = {
    EN: 'EN',
    JP: 'JP',
} as const;

export enum MasterClockType {
    MasterPulse = 'Master-pulse',
    MasterComm = 'Master-comm',
    Internal = 'Internal',
}

export type CommonLanguageType = (typeof commonLanguages)[keyof typeof commonLanguages];
